export enum SocialLoginProvider {
    GOOGLE = 'google',
    FACEBOOK = 'facebook',
    SHARE_INDIA = 'shareIndia',
    SWASTIKA = 'swastika',
    MASTERTRUST = 'masterTrust',
    PESB = 'pesb'
}

export enum TwoFATypes {
    MPIN = 'MPIN',
    OTP = 'OTP'
}

export enum AuthRole {
    USER = 'user',
    ADMIN = 'admin',
    BUSINESSPARTNER = 'businessPartner',
    SUPERDEALER = 'superDealer'
}
